// import '@mdi/font/css/materialdesignicons.css'
import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

// Override Vuetify's default font-size to match our app's base font-size
// This fixes the CSS loading order issue with Turbolinks navigation
const styleOverride = document.createElement('style')
styleOverride.textContent = `
  .v-application {
    font-size: .9rem !important;
  }
  .v-application h4 { font-size: 1.2rem !important; }
  .v-application h5 { font-size: 1rem !important; }
  .v-application h6 { font-size: .9rem !important; }
  .module {
    font-size: .9rem !important;
  }
  .module h5 { font-size: 1rem !important; }
  .module h6 { font-size: .9rem !important; }
  .module .content { font-size: .9rem !important; }
  .module .client-item,
  .module .notification-item,
  .module .task-item,
  .module .comment-item,
  .module .homework-item {
    font-size: .8rem !important;
  }
  .module .client-item .h6,
  .module .notification-item .h6,
  .module .client-item h6,
  .module .notification-item h6 {
    font-size: .8rem !important;
  }
`
document.head.appendChild(styleOverride)

Vue.use(Vuetify)

const opts = {
  theme: {
    themes: {
      light: {
        secondary: "#f2f2f2",
        accentDark: "#105865",
        accentLight: "#91d4f4",
        darkGrey: "#616161",
        accentOrange: "#FA9917",
        accentRed: "#FF5F58",
        accentGreen: '#5ed66e',
        avatarUser: '#fa9917',
        avatarSpouse: '#fa17d6',
        avatarChild: '#33e1ff',
        'teal-1': '#10819f',
        'dark-teal': '#115662',
        'm-black': '#1c1c1e',
        'gold': '#d78616',
        'l-blue': '#91d4f4',
        'green': '#6fcf97',
        'red': '#eb5757',
        'purple': '#9b51e0',
        'blue-1': '#2f80ed',
        'yellow': 'f2c94c',
        'gray-1': '#333333',
        'gray-2': '#4f4f4f',
        'gray-3': '#828282',
        'gray-4': '#bdbdbd',
        'gray-5': '#e0e0e0',
        'gray-6': '#f2f2f2'
      },
    },
  },
};

export default new Vuetify(opts)
